// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"7a858819","490":"930e2e14","787":"79d169c6","824":"46d7c459","919":"b6b8e60c","998":"4d0d45c2"}[chunkId] + ".chunk.js";
};